import React from "react";

const ImageViewer = ({ imageContent, filename }) => {
  return (
    <div className="card w-100">
      <div className="card-body">
        <div
          className="text-wrap"
          style={{
            maxHeight: "600px",
            overflowY: "auto",
          }}
        >
          <img src={imageContent} alt={filename} className="img-fluid" />
        </div>
      </div>
    </div>
  );
};

export default ImageViewer;
